import { Component, Event, EventEmitter, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "uic-table-head-filter",
    styleUrl: "table-head-filter.scss",
    shadow: true
})
export class TableFilter {
    /** These are the items that are displayed in the filter list.
     * The items are automatically filtered for identical values */
    @Prop() readonly items: [] = [];

    /** This is the name of the filter field used in the sort click event */
    @Prop() readonly field: string = "";

    /** When the confirm Button in the filter is clicked it emits the filtered items */
    @Event({
        eventName: "uicTableFilter",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    filterEvent: EventEmitter;

    private onFilterChanged(event) {
        this.filterEvent.emit({ items: event.detail, field: this.field });
    }

    render() {
        //filters identical values
        const filteredItems = [...new Set(this.items)];

        return (
            <Host onUicChange={(event) => this.onFilterChanged(event)}>
                <slot />
                &nbsp;
                <uic-filter items={filteredItems} hoist multiple>
                    <uic-icon-button slot='custom-trigger' icon='uic:filter'></uic-icon-button>
                </uic-filter>
            </Host>
        );
    }
}
